import { Button, CircularProgress } from "@material-ui/core"
import withStyles from "@material-ui/core/styles/withStyles"
import CheckIcon from "@material-ui/icons/Check"
import CloseIcon from "@material-ui/icons/Close"
import clsx from "clsx"
import PropTypes from "prop-types"
import React from "react"

import styles from "./styles"

let timeout = null

class LoaderButton extends React.PureComponent {
  componentWillUnmount() {
    if (timeout) {
      clearTimeout(timeout)
    }
  }

  state = {
    workingState: false,
    showSuccess: false,
    showError: false,
  }

  setWorking = (bool) => {
    this.setState({
      workingState: bool,
    })
  }

  showSuccess = () => {
    this.setState({
      showSuccess: true,
      workingState: false,
    })
    timeout = setTimeout(() => {
      this.setState({
        showSuccess: false,
      })
    }, 1500)
  }

  showError = () => {
    this.setState({
      showError: true,
      workingState: false,
    })
    timeout = setTimeout(() => {
      this.setState({
        showError: false,
      })
    }, 1500)
  }

  render() {
    const {
      classes,
      children,
      classoverrides,
      theme,
      working,
      formik,
      ...rest
    } = this.props

    const { workingState, showSuccess, showError } = this.state

    return (
      <div
        className={clsx(classes.wrapper, classoverrides.wrapper, {
          [classes.wrapperFullWidth]: this.props.fullWidth,
        })}
      >
        <Button
          disabled={working || workingState || (formik && formik.isSubmitting)}
          type="submit"
          {...rest}
          className={classes.button}
          classes={classoverrides.button}
        >
          <div
            className={clsx(classes.promiseSuccessIcon, {
              [classes.showPromiseIcon]: showSuccess,
            })}
          >
            <CheckIcon
              className={clsx(classes.checkIcon, classes.promiseIcon)}
            />
          </div>
          <div
            className={clsx(classes.promiseErrorIcon, {
              [classes.showPromiseIcon]: showError,
            })}
          >
            <CloseIcon
              className={clsx(classes.closeIcon, classes.promiseIcon)}
            />
          </div>
          {children}
        </Button>
        {(working || workingState || (formik && formik.isSubmitting)) && (
          <CircularProgress
            color={
              !this.props.hasOwnProperty("variant") ||
              this.props.variant === "text"
                ? "primary"
                : "text"
            }
            size={24}
            className={classes.buttonProgress}
            classes={classoverrides.circularProgress}
          />
        )}
      </div>
    )
  }
}

LoaderButton.propTypes = {
  onClick: PropTypes.func,
  classes: PropTypes.object,
  children: PropTypes.object,
  classoverrides: PropTypes.object,
  theme: PropTypes.object,
  working: PropTypes.object,
  formik: PropTypes.object,
  fullWidth: PropTypes.object,
  variant: PropTypes.object,
}

LoaderButton.defaultProps = {
  classoverrides: {
    wrapper: {},
  },
}

export default withStyles(styles, { withTheme: true, name: "CAT" })(
  LoaderButton
)
